import { GET_FILE } from "../Trips/constants";
import {
    GET_OFFSET_LOADING,GET_DEVICES, CLEAR_DEVICES, ERROR_DEVICES,GET_DEVICES_MASTER_LIST,ERROR_DEVICES_MASTER_LIST,GET_EXCEL_DATA,ERROR_GET_EXCEL_DATA,UPDATE_DEVICE_IN_LIST
} from "./constants";

const initialState = {
    loading: true,
    count: 0,
    limit: 0,
    offset: 0,
    error: '',
    devices: [],
    devicesMasterList: [],
    datafile:'',
    registerDevices:[],
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
    const { type, payload ,headers} = action;
    switch (type) {
        case GET_OFFSET_LOADING:
            return {
                ...state,
                loading: true,
            }
        case GET_DEVICES:
            return {
                ...state,
                devices: payload.devices.dev_list,
                count: payload.devices.dev_count,//payload.devices.length,
                loading: false,
                limit: payload.devices.limit,
                offset: payload.devices.offset,
            }
        
        case UPDATE_DEVICE_IN_LIST: {
            // Update device in the main devices list to reflect changes from editing
            const { deviceID, updatedData } = payload;
            console.log('📋 devices reducer: UPDATE_DEVICE_IN_LIST', { deviceID, updatedData });
            
            const updatedDevices = state.devices.map(device => {
                if (device.deviceID === deviceID) {
                    console.log('✨ Found device to update in list:', device.deviceName);
                    return {
                        ...device,
                        deviceName: updatedData.deviceName || device.deviceName,
                        // Update any other device properties that might be displayed on the main list
                        // Note: metaInfo might not be directly displayed on the main page,
                        // but we can update specific fields that are shown
                        acruxBrdId: updatedData.acruxBrdId || device.acruxBrdId,
                        lastUpdated: new Date().toISOString(), // Add timestamp for debugging
                    };
                }
                return device;
            });
            
            console.log('🎯 devices reducer: Updated devices list', updatedDevices.length);
            return {
                ...state,
                devices: updatedDevices,
            };
        }
        
        case GET_DEVICES_MASTER_LIST:
            return {
                ...state,
                devicesMasterList: payload.devices.dev_list,
                    
            }
        case GET_EXCEL_DATA:
            return{
                ...state,
                registerDevices :payload.registerDevices,
            };
        case ERROR_GET_EXCEL_DATA:
        case ERROR_DEVICES_MASTER_LIST:
        case ERROR_DEVICES:
            return {
                ...state,
                error: payload,
                devices: [],
                devicesMasterList:[],
                loading: false,
                count: 0,
                registerDevices:[],
            }
        case CLEAR_DEVICES:
            return {
                ...state,
                loading: true,
                count: 0,
                error: '',
                devicesMasterList:[],
                devices: [],
                registerDevices:[],
            }
            
        default:
            return state;
    }
}